import React, { useState, useEffect } from 'react';
import Progress from '../atoms/Progress';
import Button from '../atoms/Button';
import { useTranslation } from 'next-i18next';
import styles from '../../styles/components/molecules/StepNavi.module.scss';

interface CreateItemProps {
  steps?: string[];
  className?: string;
  startLabel?: string;
  endLabel?: string;
  nextLabel?: string;
  backLabel?: string;
  intro?: boolean;
  nextDisabled?: boolean;
  disabled?: boolean;
  currStep?: number;
  onChange?: (step: number) => void;
  onNext?: (step: number) => void;
  onBack?: (step: number) => void;
  onComplete?: (step: number) => void;
}

export default function CreateItem(props: CreateItemProps) {
  const { t } = useTranslation(['common']);
  const {
    intro = true,
    steps = ['intro', 'step 1', 'step 2', 'outro'],
    startLabel = t(`common:start`),
    endLabel = t(`common:complete`),
    nextLabel = t(`common:cta-next`),
    backLabel = t(`common:cta-back`),
    disabled,
    nextDisabled,
    onChange,
    onNext,
    onBack,
    onComplete,
    currStep = 0,
    className,
  } = props;

  const [step, setStep] = useState(currStep);

  const lastStep = steps.length - 1;
  const percLastStep = intro ? lastStep : lastStep + 1;
  const percCurrStep = intro ? step : step + 1;
  const percentage = parseInt(`${(percCurrStep / percLastStep) * 100}`);

  const onStep = (nextStep: number) => {
    !!onChange && onChange(nextStep);
    if (nextStep === steps.length) {
      !!onComplete && onComplete(nextStep);
    } else if (nextStep > step) {
      !!onNext && onNext(nextStep);
      setStep(nextStep);
    } else if (step > 0 && nextStep < step) {
      !!onBack && onBack(nextStep);
      setStep(nextStep);
    }
  };

  useEffect(() => {
    setStep(currStep);
  }, [currStep]);

  return (
    <>
      <div className={`${styles.stepNavi} ${className}`}>
        {intro && step === 0 ? (
          <Button
            full
            large
            dark
            colored
            disabled={disabled}
            label={startLabel}
            onClick={() => onStep(step + 1)}
          />
        ) : (
          <>
            {steps.length > 1 && (
              <Button
                half
                float
                medium
                iconLeft
                disabled={disabled || step === 0}
                label={backLabel}
                onClick={() => onStep(step - 1)}
              />
            )}
            <Button
              half
              float
              medium
              disabled={disabled || nextDisabled}
              label={step === lastStep ? endLabel : nextLabel}
              onClick={() => onStep(step + 1)}
            />
            <Progress
              medium
              disabled={disabled || nextDisabled}
              value={percentage}
            />
          </>
        )}
      </div>
    </>
  );
}
